import { FunctionComponent, ReactElement, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { Props } from './types';

const PublicLayoutPortal: FunctionComponent<Props> = ({ children, removeScrollBlocker }) => {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        document.documentElement.style.overflow = removeScrollBlocker ? null :  'hidden';
        setMounted(true);

        return () => {
            document.documentElement.style.overflow = null;
            setMounted(false);
        };
    }, [removeScrollBlocker]);

    return mounted
        ? createPortal(children,
            document.querySelector('#react-portal')) as ReactElement
        : null;
};

export default PublicLayoutPortal;
